var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-admin-wrap layout-sidebar-vertical clearfix sidebar-full"},[_c('system-sidebar'),_c('main',[_c('div',{staticClass:"main-content-wrap mt-0 bg-off-white",class:{
                'vertical-sidebar': _vm.getVerticalSidebar.isVerticalSidebar,
                compact: _vm.getVerticalSidebar.isVerticalCompact,
            }},[_c('system-topbar'),_c('div',{staticClass:"container-fluid px-0"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }